<div class="page-container">
  <div class="public-card">
    <p-card class="card">
      @if (logo) {
        <div class="align-center">
          <img [priority]="true" alt="" class="public-logo img-width100" height="76" ngSrc="assets/images/{{logo}}" width="286"/>
        </div>
      }
      <div class="page-container">
        @if (verifyPath) {
          <div>
            <h2>Verify Invitation</h2>
            <p>Please provide the following data to verify your invitation. Thank you and Welcome!</p>
            <form [formGroup]="mainForm" class="user-registration-form">
              <div class="p-grid p-fluid">
                <div class="col-md-6 col-sm-12 col-xs-12">
                  <div class="p-fieldset-content p-mt-2">
                    <label>Password/Passphrase<sup class="req">*</sup></label>
                    <input [type]="passwordType" formControlName="password" pInputText>
                    @if (mainForm.controls.password.invalid && mainForm.controls.password.dirty) {
                      <div class="p-error">
                        @if (mainForm.controls.password.errors?.required) {
                          <div>Password is required</div>
                        }
                        <!--                <div *ngIf="changePasswordForm.controls.password.errors?.pattern">Must contain at least one uppercase and lowercase letter, one number, one special character, and be at least 10 characters long</div>-->
                        @if (mainForm.controls.password.hasError('length')) {
                          <div>Must be at least 10 characters long</div>
                        }
                        @if (mainForm.controls.password.hasError('uppercase')) {
                          <div>Must contain at least one uppercase letter (A-Z)</div>
                        }
                        @if (mainForm.controls.password.hasError('lowercase')) {
                          <div>Must contain at least one lowercase letter (a-z)</div>
                        }
                        @if (mainForm.controls.password.hasError('number')) {
                          <div>Must contain at least one number (0-9)</div>
                        }
                        @if (mainForm.controls.password.hasError('special')) {
                          <div [innerHTML]="'Must contain at least one special character ($@#!%*?&)'"></div>
                        }
                        @if (mainForm.controls.password.hasError('repeats')) {
                          <div>Must have no more than 2 identical characters in a row (999 not allowed)</div>
                        }
                        @if (mainForm.controls.password.hasError('customValidator')) {
                          <div>No parts of your username</div>
                        }
                      </div>
                    }
                    <div class="checkbox-container">
                      <p-checkbox [binary]="true" class="checkbox p-mt-2" formControlName="showPassword" label="Show Password"></p-checkbox>
                      <label>Show Password</label>
                    </div>
                  </div>
                  <div class="p-fieldset-content p-mt-2">
                    <label>Confirm Password/Passphrase<sup class="req">*</sup></label>
                    <input [type]="passwordConfirmType" formControlName="passwordConfirm" pInputText>
                    @if (mainForm.controls.passwordConfirm.invalid && mainForm.controls.passwordConfirm.dirty) {
                      <div class="p-error">
                        @if (mainForm.controls.passwordConfirm.errors?.required) {
                          <div>Confirm Password is required</div>
                        }
                        @if (mainForm.controls.passwordConfirm.errors?.confirmedValidator) {
                          <div>Password & Confirm Password do not match</div>
                        }
                      </div>
                    }
                    <div class="checkbox-container">
                      <p-checkbox [binary]="true" class="checkbox p-mt-2" formControlName="showPasswordConfirm"></p-checkbox>
                      <label>Show Password</label>
                    </div>
                  </div>
                  <div class="p-fieldset-content p-mt-2">
                    <!--            <span class="align-right"><a href="https://www.useapassphrase.com/" target="_blank" rel="noopener noreferrer" title="Why use a passphrase?">Why use a passphrase?</a></span>-->
                    <span (click)="toggleRequirements()" class="link">Requirements</span>
                    @if (requirements) {
                      <ul>
                        <li>Must be at least 10 characters long</li>
                        <li>Must contain at least one uppercase letter (A-Z)</li>
                        <li>Must contain at least one lowercase letter (a-z)</li>
                        <li>Must contain at least one number (0-9)</li>
                        <li [innerHTML]="'Must contain at least one special character ($@#!%*?&)'"></li>
                        <li>Must have no more than 2 identical characters in a row (999 not allowed)</li>
                        <li>No parts of your username</li>
                      </ul>
                    }
                  </div>
                </div>
                <div class="col-md-6 col-sm-12 col-xs-12">
                  <div class="p-fieldset-content p-mt-2">
                    @if (showQuestion1Id) {
                      <app-select (emitData)="getQuestion1Data($event)" [inputObj]="inputObjQuestion1" class="full-width"></app-select>
                    }
                  </div>
                  <div class="p-fieldset-content p-mt-2">
                    <label>Answer<sup class="req">*</sup></label>
                    <input formControlName="answer1" maxlength="100" pInputText>
                    @if (mainForm.controls.answer1.invalid && mainForm.controls.answer1.dirty) {
                      <div class="p-error">
                        @if (mainForm.controls.answer1.errors?.required) {
                          <div>An answer is required</div>
                        }
                        @if (mainForm.controls.answer1.errors?.minlength) {
                          <div>Answer must be between 4 and 100 characters</div>
                        }
                      </div>
                    }
                  </div>
                  <div class="p-fieldset-content p-mt-2">
                    @if (showQuestion2Id) {
                      <app-select (emitData)="getQuestion2Data($event)" [inputObj]="inputObjQuestion2" class="full-width"></app-select>
                    }
                  </div>
                  <div class="p-fieldset-content p-mt-2">
                    <label>Answer<sup class="req">*</sup></label>
                    <input formControlName="answer2" maxlength="100" pInputText>
                    @if (mainForm.controls.answer2.invalid && mainForm.controls.answer2.dirty) {
                      <div class="p-error">
                        @if (mainForm.controls.answer2.errors?.required) {
                          <div>An answer is required</div>
                        }
                        @if (mainForm.controls.answer2.errors?.minlength) {
                          <div>Answer must be between 4 and 100 characters</div>
                        }
                      </div>
                    }
                  </div>
                  <div class="p-fieldset-content p-mt-2">
                    @if (showQuestion3Id) {
                      <app-select (emitData)="getQuestion3Data($event)" [inputObj]="inputObjQuestion3" class="full-width"></app-select>
                    }
                  </div>
                  <div class="p-fieldset-content p-mt-2">
                    <label>Answer<sup class="req">*</sup></label>
                    <input formControlName="answer3" maxlength="100" pInputText>
                    @if (mainForm.controls.answer3.invalid && mainForm.controls.answer3.dirty) {
                      <div class="p-error">
                        @if (mainForm.controls.answer3.errors?.required) {
                          <div>An answer is required</div>
                        }
                        @if (mainForm.controls.answer3.errors?.minlength) {
                          <div>Answer must be between 4 and 100 characters</div>
                        }
                      </div>
                    }
                  </div>
                </div>
                <!--                <div class="col-md-4 col-sm-12 col-xs-12">-->
                <!--                  <div class="p-fieldset-content p-mt-2">-->
                <!--                    <label>Date Of Birth<sup class="req">*</sup></label>-->
                <!--                    <p-datepicker dateMask  dateFormat="mm/dd/yy" formControlName="dateOfBirth" appendTo="body" placeholder="mm/dd/yyyy" [showIcon]="true"  yearRange="1950:2035"></p-datepicker>-->
                <!--                    @if ((mainForm.controls.dateOfBirth.dirty) &&-->
                <!--                      mainForm.controls.dateOfBirth.errors?.required) {-->
                <!--                      <span class="p-error">'Date Of Birth' must be provided</span>-->
                <!--                    }-->
                <!--                  </div>-->
                <!--                  <div class="p-fieldset-content p-mt-2 mask-container">-->
                <!--                    <label>Mobile Phone #<sup class="req">*</sup></label>-->
                <!--                    <p-inputmask formControlName="primaryPhoneNumber" [className]="'form-input no-border'" mask="(999) 999-9999"-->
                <!--                    unmask="true"></p-inputmask>-->
                <!--                    @if ((mainForm.controls.primaryPhoneNumber.dirty) &&-->
                <!--                      mainForm.controls.primaryPhoneNumber.errors?.required) {-->
                <!--                      <span class="p-error">'Mobile Phone #' must be provided</span>-->
                <!--                    }-->
                <!--                  </div>-->
                <!--                  <div class="p-fieldset-content p-mt-2">-->
                <!--                    <label>{{'Member #'|labelReplace}}</label>-->
                <!--                    <input type="text" pInputText  formControlName="memberNumber">-->
                <!--                    <p>(Not Required)</p>-->
                <!--                  </div>-->
                <!--                </div>-->
              </div>
              <div class="tab-form-buttons p-mt-2">
                @if (!isVerifying) {
                  <p-button (click)="verify()" [className]="'inline-button'" [disabled]="mainForm.invalid || !mainForm.dirty" class="p-button-info p-mr-2" label="Verify Invitation"
                            pTooltip="Verify Invitation" tooltipPosition="bottom"></p-button>
                }
                @if (isVerifying) {
                  <p-button [className]="'inline-button'" [disabled]="true" class="p-button-info p-mr-2" label="Verify Invitation">
                    <i class="pi pi-spin pi-spinner save-spinner"></i>
                  </p-button>
                }
              </div>
            </form>
          </div>
        }
        @if (expiredPath) {
          <div>
            <h2>Create an Account</h2>
            <p>The window to respond to your invitation has expired. Please register to continue.</p>
            <form [formGroup]="mainFormExpired" class="user-registration-form">
              <div class="p-grid p-fluid">
                <div class="col-md-4 col-sm-12 col-xs-12">
                  <div class="p-fieldset-content">
                    <label>Username (E-mail)<span class="ut-requireddenotation"> *</span></label>
                    <input formControlName="username" pInputText type="email">
                    @if (mainFormExpired.controls.username.invalid && mainFormExpired.controls.username.dirty) {
                      <div class="p-error">
                        @if (mainFormExpired.controls.username.errors?.required) {
                          <div>Username is required</div>
                        }
                        @if (mainFormExpired.controls.username?.errors) {
                          <div>Username must be a valid e-mail address</div>
                        }
                      </div>
                    }
                  </div>
                  <div class="p-fieldset-content p-mt-2">
                    <label>Password/Passphrase<sup class="req">*</sup></label>
                    <input [type]="passwordType" formControlName="password" pInputText>
                    @if (mainFormExpired.controls.password.invalid && mainFormExpired.controls.password.dirty) {
                      <div class="p-error">
                        @if (mainFormExpired.controls.password.errors?.required) {
                          <div>Password is required</div>
                        }
                        <!--                <div *ngIf="changePasswordForm.controls.password.errors?.pattern">Must contain at least one uppercase and lowercase letter, one number, one special character, and be at least 10 characters long</div>-->
                        @if (mainFormExpired.controls.password.hasError('length')) {
                          <div>Must be at least 10 characters long</div>
                        }
                        @if (mainFormExpired.controls.password.hasError('uppercase')) {
                          <div>Must contain at least one uppercase letter (A-Z)</div>
                        }
                        @if (mainFormExpired.controls.password.hasError('lowercase')) {
                          <div>Must contain at least one lowercase letter (a-z)</div>
                        }
                        @if (mainFormExpired.controls.password.hasError('number')) {
                          <div>Must contain at least one number (0-9)</div>
                        }
                        @if (mainFormExpired.controls.password.hasError('special')) {
                          <div [innerHTML]="'Must contain at least one special character ($@#!%*?&)'"></div>
                        }
                        @if (mainFormExpired.controls.password.hasError('repeats')) {
                          <div>Must have no more than 2 identical characters in a row (999 not allowed)</div>
                        }
                        @if (mainFormExpired.controls.password.hasError('customValidator')) {
                          <div>No parts of your username</div>
                        }
                      </div>
                    }
                    <div class="checkbox-container">
                      <p-checkbox [binary]="true" class="checkbox p-mt-2" formControlName="showPassword" label="Show Password"></p-checkbox>
                      <label>Show Password</label>
                    </div>
                  </div>
                  <div class="p-fieldset-content p-mt-2">
                    <label>Confirm Password/Passphrase<sup class="req">*</sup></label>
                    <input [type]="passwordConfirmType" formControlName="passwordConfirm" pInputText>
                    @if (mainFormExpired.controls.passwordConfirm.invalid && mainFormExpired.controls.passwordConfirm.dirty) {
                      <div class="p-error">
                        @if (mainFormExpired.controls.passwordConfirm.errors?.required) {
                          <div>Confirm Password is required</div>
                        }
                        @if (mainFormExpired.controls.passwordConfirm.errors?.confirmedValidator) {
                          <div>Password & Confirm Password do not match</div>
                        }
                      </div>
                    }
                    <div class="checkbox-container">
                      <p-checkbox [binary]="true" class="checkbox p-mt-2" formControlName="showPasswordConfirm" label="Show Password"></p-checkbox>
                      <label>Show Password</label>
                    </div>
                  </div>
                  <div class="p-fieldset-content p-mt-2">
                    <!--            <span class="align-right"><a href="https://www.useapassphrase.com/" target="_blank" rel="noopener noreferrer" title="Why use a passphrase?">Why use a passphrase?</a></span>-->
                    <span (click)="toggleRequirements()" class="link">Requirements</span>
                    @if (requirements) {
                      <ul>
                        <li>Must be at least 10 characters long</li>
                        <li>Must contain at least one uppercase letter (A-Z)</li>
                        <li>Must contain at least one lowercase letter (a-z)</li>
                        <li>Must contain at least one number (0-9)</li>
                        <li [innerHTML]="'Must contain at least one special character ($@#!%*?&)'"></li>
                        <li>Must have no more than 2 identical characters in a row (999 not allowed)</li>
                        <li>No parts of your username</li>
                      </ul>
                    }
                  </div>
                  <div class="p-fieldset-content tab-form-buttons p-mt-2">
                    @if (!isVerifying) {
                      <p-button (click)="signUp()" [className]="'inline-button'" [disabled]="mainFormExpired.invalid || !mainFormExpired.dirty" class="p-button-info p-mr-2" label="Register"
                                pTooltip="Register" tooltipPosition="bottom"></p-button>
                    }
                    @if (isVerifying) {
                      <p-button [className]="'inline-button'" [disabled]="true" class="p-button-info p-mr-2" label="Register">
                        <i class="pi pi-spin pi-spinner save-spinner"></i>
                      </p-button>
                    }
                  </div>
                </div>
              </div>
            </form>
          </div>
        }
        @if (unlinkedPath) {
          <div>
            <h2>Verify Invitation</h2>
            <p>We're close, but have one additional request. Please provide the following so your account may be appropriately linked.</p>
            <form [formGroup]="mainFormUnlinked" class="user-registration-form">
              <div class="p-grid p-fluid">
                <div class="col-md-4 col-sm-12 col-xs-12">
                  <div class="p-fieldset-content p-mt-2">
                    <label>First Name<sup class="req">*</sup></label>
                    <input formControlName="firstName" pInputText type="text">
                    @if ((mainFormUnlinked.controls.firstName.dirty) &&
                    mainFormUnlinked.controls.firstName.errors?.required) {
                      <span class="p-error">'First Name' must be provided</span>
                    }
                  </div>
                  <div class="p-fieldset-content p-mt-2">
                    <label>Last Name<sup class="req">*</sup></label>
                    <input formControlName="lastName" pInputText type="text">
                    @if ((mainFormUnlinked.controls.lastName.dirty) &&
                    mainFormUnlinked.controls.lastName.errors?.required) {
                      <span class="p-error">'Last Name' must be provided</span>
                    }
                  </div>
                  <div class="p-fieldset-content tab-form-buttons p-mt-2">
                    @if (!isVerifying) {
                      <p-button (click)="attemptToLink()" [className]="'inline-button'" [disabled]="mainFormUnlinked.invalid || !mainFormUnlinked.dirty" class="p-button-info p-mr-2" label="Submit"
                                pTooltip="Submit" tooltipPosition="bottom"></p-button>
                    }
                    @if (isVerifying) {
                      <p-button [className]="'inline-button'" [disabled]="true" class="p-button-info p-mr-2" label="Submit">
                        <i class="pi pi-spin pi-spinner save-spinner"></i>
                      </p-button>
                    }
                  </div>
                </div>
              </div>
            </form>
          </div>
        }
      </div>
    </p-card>
  </div>
  <p-toast [baseZIndex]="16000"></p-toast>
</div>
